import React from 'react';
import { TbPercentage } from 'react-icons/tb';

const CouponPage: React.FC<any> = ({ inputCode, handleApply, listOfCoupen, appliedCouponName, handleRemoveCoupon }) => {
  return (
    <>
      <div className='pb-4 px-4 mt-4 border bg-white rounded shadow-md font-poppins min-h-[100vh] sm:min-h-[100vh] md:min-h-fit '>
        {/* Coupon List */}
        <div className='grid mt-4 grid-cols-1 gap-4'>
          {(!listOfCoupen.current || listOfCoupen.current.length === 0) && (
            <div>
              <p className={'text-sm mt-2  text-black text-center'}>
                <strong className='text-base'>Sorry!</strong> <br />
                No Offers available.
              </p>
            </div>
          )}

          {listOfCoupen.current &&
            listOfCoupen.current.length > 0 &&
            listOfCoupen.current.map((coupon: any, index: any) => (
              <div
                key={index}
                className={`border rounded-lg shadow p-4 relative transition-all
                            ${inputCode === coupon.coupon_code ? 'border-blue-500' : ''}
                            ${appliedCouponName && appliedCouponName !== coupon.name ? 'opacity-50 pointer-events-none' : ''}
                        `}
              >
                <div className='flex justify-between'>
                  <div className='flex items-center'>
                    <TbPercentage className='mr-4 w-7 h-7 p-1 text-white rounded-full bg-[#552B18]' />
                    <span className='border border-black border-dashed rounded px-3 py-[2px] text-sm font-semibold bg-gray-100 inline-block'>
                      {coupon.coupon_code}
                    </span>
                  </div>

                  {/* Apply / Remove Button */}
                  {appliedCouponName === coupon.name ? (
                    <button
                      onClick={() => handleRemoveCoupon(coupon.name)}
                      className='text-[#C12E2A] font-semibold text-xs'
                    >
                      Remove
                    </button>
                  ) : (
                    <button onClick={() => handleApply(coupon.name)} className='text-[#008810ff] font-semibold text-xs'>
                      Apply
                    </button>
                  )}
                </div>

                <div className='text-base border-b-2 border-[#9E9E9E] border-dashed pt-2 pb-2 w-full'>
                  {coupon.name}
                </div>

                {coupon.description ? (
                  <div
                    className={'text-sm mt-2 [&_*]:text-black'}
                    dangerouslySetInnerHTML={{ __html: coupon.description }}
                  />
                ) : (
                  <p className={'text-sm mt-2  text-black'}>No description available.</p>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default CouponPage;
